import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminDashboardComponent {
  constructor (AdminDashboard, $localStorage) {
    this.AdminDashboard = AdminDashboard
    this.$localStorage = $localStorage
  }

  $onInit () {
    this.promise = this.AdminDashboard.get()
      .then((response) => (this.data = response.data))
      .then(() => (this.token = this.$localStorage.token))
  }
}

module.component('fanconsultoresAdminDashboard', {
  controller: FanconsultoresAdminDashboardComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/dashboard/component.js